import { defineMessages } from 'react-intl';

// This contains all the translatable interface messages.
const messages = defineMessages({
  // intro scenario
  introTitle: {
    id: '0IMfEB',
    defaultMessage: 'Welcome to IBM Cloud Pak for AIOps',
  },
  introDescription: {
    id: 'P794c5',
    defaultMessage: `IBM Cloud Pak® for AIOps deploys AI across your toolchain to help you resolve incidents quickly. Using data collected from your ITOps environment, IBM Cloud Pak for AIOps alerts your team to problems, reduces noise, identifies root causes, and recommends solutions for your mission-critical applications.
    
    In this experience, you’ll be able to explore IBM Cloud Pak for AIOps through different roles to see how AI can make your IT operations more intelligent.`,
  },
  introAlt: {
    id: 'MsUXMD',
    defaultMessage:
      'Four small circles and with data tools and cogs under a big circle with two people creating data on a semi circular board',
  },
  modalCta: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  // profile selection scenario
  profileTitle: {
    id: '70wBo6',
    defaultMessage: 'Pick your role',
  },
  profileDescription: {
    id: 'W4xn0P',
    defaultMessage: `Carlos and Todd both work on an application for ordering robots called
    Robot Shop. Pick one to take their journey with IBM Cloud Pak® for AIOps.`,
  },
  // SRE profile data
  profileSreTitle: {
    id: 'BPM3z8',
    defaultMessage: 'Carlos',
  },
  profileSreRole: {
    id: 'q6qENs',
    defaultMessage: 'Site Reliability Engineer',
  },
  profileSreCopy: {
    id: 'KDH/CV',
    defaultMessage:
      'As a site reliability engineer (SRE), you are part of a team responsible for managing Robot Shop. To get an idea of how IBM Cloud Pak for AIOps can help you manage your application, explore the available use cases.',
  },
  profileSreAlt: {
    id: 'aRDkDH',
    defaultMessage:
      'A man wearing glasses and a white shirt, representing a site reliability engineer',
  },
  // Admin profile data
  profileAdminTitle: {
    id: 's0O1AQ',
    defaultMessage: 'Todd',
  },
  profileAdminRole: {
    id: '3wmuyF',
    defaultMessage: 'Administrator',
  },
  profileAdminCopy: {
    id: 'HNgCJE',
    defaultMessage:
      'As an administrator, you play a crucial role in configuring infrastructure and tooling for your team. To get an idea of how IBM Cloud Pak for AIOps can help you set up Robot Shop, explore the available use cases.',
  },
  profileAdminAlt: {
    id: 'ncB+ZQ',
    defaultMessage:
      'Long-haired man with beard wearing pink shirt, representing an infrastructure Administrator',
  },
  // SideBar data
  sidebarTitle: {
    id: 'v5OMpx',
    defaultMessage: 'Interactive experience',
  },
  sidebarLabel: {
    id: 'Eig3D3',
    defaultMessage: 'Use Cases',
  },
  // sidebar items - SRE
  sidebarSreItemsIntro: {
    id: 'Hnl7vt',
    defaultMessage: `Hi Carlos the SRE. 
    Please select the use case you’d like to explore.`,
  },
  sidebarSreItem1Title: {
    id: 'jvhWnI',
    defaultMessage: 'Get familiar with the dashboard',
  },
  sidebarSreItem1Copy: {
    id: 'V6n5gu',
    defaultMessage:
      'Take a general tour around the key capabilities of IBM IBM Cloud Pak® for AIOps.',
  },
  sidebarSreItem2Title: {
    id: 'g1KKwq',
    defaultMessage: 'Resolve an incident with AI',
  },
  sidebarSreItem2Copy: {
    id: 'x/tNmc',
    defaultMessage:
      'Learn how IBM Cloud Pak for AIOps can help you resolve incidents faster using AI to investigate, assess, and resolve an out of memory error in Robot Shop.',
  },
  sidebarSreItem3Title: {
    id: 'appizC',
    defaultMessage: 'Using metric anomaly detection',
  },
  sidebarSreItem3Copy: {
    id: '4N8jxD',
    defaultMessage:
      'Learn how metric anomaly detects alerts, finds related alerts, and forecasts future events.',
  },
  sidebarSreItem4Title: {
    id: 'XpOj8h',
    defaultMessage: 'Assess the risk of a proposed change',
  },
  sidebarSreItem4Copy: {
    id: '89eRPT',
    defaultMessage:
      'Learn about the value of assessing changes to your applications before you make them.',
  },
  // sidebar items - Admin
  sidebarAdminItemsIntro: {
    id: 'YQQKZk',
    defaultMessage: `Hi Todd the Administrator
      Please select the use case you’d like to explore.`,
  },
  sidebarAdminItem1Title: {
    id: 'ncLsSy',
    defaultMessage: 'Connect data sources',
  },
  sidebarAdminItem1Copy: {
    id: 'rKL3Rd',
    defaultMessage:
      'Learn about tools available for connections and see how to bring in sample data for Robot Shop.',
  },
  sidebarAdminItem2Title: {
    id: 'oDbzO6',
    defaultMessage: 'Define and manage an application',
  },
  sidebarAdminItem2Copy: {
    id: '2I2Qau',
    defaultMessage:
      'Define the Robot Shop application and see how you can manage it.',
  },
  sidebarAdminItem3Title: {
    id: '6ctxhX',
    defaultMessage: 'Train data for AI models',
  },
  sidebarAdminItem3Copy: {
    id: 'zz+7eb',
    defaultMessage: 'Select an AI type to train on Robot Shop data.',
  },
});

export default messages;
